package org.olafneumann.regex.generator

open class RegexGeneratorException(
    message: String,
    cause: Throwable? = null
) : Exception(message, cause)
